// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 800px) {
    .table {
        display: none;
    }

    .col-chart-6 {
        width: 90vw;
    }

    .menu-customer {
        display: none;
    }

    .col-money-5 {
        width: 75vw;
    }

    .person-info {
        background-color: #FFFFFF;
        margin-top: 3vh;
        width: 80vw;
    }

    .person-info-item {
        width: 65vw;
    }

    .btn-save {
        cursor: pointer;
        width: 30vw;
        padding: 5px;
        background: #2CA5EC;
        box-shadow: 4px 5px 25px rgba(27, 27, 27, 0.08);
        border-radius: 5px;
    }

    .border-b {
        border: #3F3F3F solid 1px;
    }
}

@media (min-width: 800px) {
    .f-raleway-reg-obj {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        /* identical to box height */
      
        font-feature-settings: 'pnum' on, 'lnum' on;
      
        /* Текст */
      
        color: #3F3F3F;
      }
    .birthday {
        border-color: #c8c7c7;
        border-radius: 5px;
        border-width: 1px;
        border-style: solid;
        height: 5vh;
        width: 9vw;
        padding-left: 5px;
    }
    .order-info-container {
        width: 40vw;
    }
    .order {
        cursor: pointer;
    }
    .order-hidden {
        display: none;
    }
    .order:hover {
        background-color: #a4a3a3;
    }
    .mobile-table {
        display: none;
    }
    .col-chart-6 {
        width: 45vw;
    }

    .col-money-5 {
        width: 18vw;
    }

    .person-info {
        background-color: #FFFFFF;
        margin-top: 3vh;
        width: 75vw;
    }

    .person-info-item {
        width: 45vw;
    }

    .btn-save {
        cursor: pointer;
        width: 10vw;
        padding: 5px;
        background: #2CA5EC;
        box-shadow: 4px 5px 25px rgba(27, 27, 27, 0.08);
        border-radius: 5px;
    }
}


.person-body {
    background-color: #FAFAFA;
    padding: 5vmax;
}

.person-info {
    background-color: #FFFFFF;
    margin-top: 3vh;
}

.person-input {
    background-color: #FAFAFA;
}



.btn-save:hover {
    background: #0f95e3;
}

.text-btn-save {
    color: #FFFFFF;
}

.text-main {
    cursor: pointer;
}

.text-change-password {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    /* identical to box height, or 16px */

    font-feature-settings: 'pnum' on, 'lnum' on;

    /* Текст */

    color: #3F3F3F;

    cursor: pointer;
}

.chart-container {
    height: 40vh;
    /* width: 100vw; */
}

.bluemarker::marker {
    color: #0088FE;
    /* font-size: 1.5em; */
}

.greenmarker::marker {
    color: #00C49F;
}

.orangemarker::marker {
    color: #FFBB28;
}

.bg-w {
    background-color: #FFFFFF;
}

.brd-r5 {
    border-radius: 5px;
}

.fs-13 {
    font-size: 13px;
}

.h-text {
    height: 3vh;
}

.bl {
    border-left: rgba(0, 0, 0, 0.08);
    border-left-width: 2px;
    border-left-style: solid;
}

.font-obj-text-sel {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    color: black;
}

.credit-info {
    color: #0088FE;
    cursor: pointer;
}

.credit-info:hover {
    font-weight: bold;
}

.font-filter-credit {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    font-size: 11px;
    color: black;
}

.credit-hidden {
    display: none;
}

.btn-add-test {
    background-color: #e3dfdf;
    display: flex;
    justify-content: center;
    border-radius: 10px;
}

.btn-add-test :hover {
    background-color: #838181;
}

.p-7 {
    padding: 7px;
}





`, "",{"version":3,"sources":["webpack://./src/components/personal/style.css"],"names":[],"mappings":"AAAA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,+CAA+C;QAC/C,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,4BAA4B;;QAE5B,2CAA2C;;QAE3C,UAAU;;QAEV,cAAc;MAChB;IACF;QACI,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,+CAA+C;QAC/C,kBAAkB;IACtB;AACJ;;;AAGA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,2CAA2C;;IAE3C,UAAU;;IAEV,cAAc;;IAEd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB","sourcesContent":["@media (max-width: 800px) {\n    .table {\n        display: none;\n    }\n\n    .col-chart-6 {\n        width: 90vw;\n    }\n\n    .menu-customer {\n        display: none;\n    }\n\n    .col-money-5 {\n        width: 75vw;\n    }\n\n    .person-info {\n        background-color: #FFFFFF;\n        margin-top: 3vh;\n        width: 80vw;\n    }\n\n    .person-info-item {\n        width: 65vw;\n    }\n\n    .btn-save {\n        cursor: pointer;\n        width: 30vw;\n        padding: 5px;\n        background: #2CA5EC;\n        box-shadow: 4px 5px 25px rgba(27, 27, 27, 0.08);\n        border-radius: 5px;\n    }\n\n    .border-b {\n        border: #3F3F3F solid 1px;\n    }\n}\n\n@media (min-width: 800px) {\n    .f-raleway-reg-obj {\n        font-family: 'Raleway';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 12px;\n        line-height: 18px;\n        /* identical to box height */\n      \n        font-feature-settings: 'pnum' on, 'lnum' on;\n      \n        /* Текст */\n      \n        color: #3F3F3F;\n      }\n    .birthday {\n        border-color: #c8c7c7;\n        border-radius: 5px;\n        border-width: 1px;\n        border-style: solid;\n        height: 5vh;\n        width: 9vw;\n        padding-left: 5px;\n    }\n    .order-info-container {\n        width: 40vw;\n    }\n    .order {\n        cursor: pointer;\n    }\n    .order-hidden {\n        display: none;\n    }\n    .order:hover {\n        background-color: #a4a3a3;\n    }\n    .mobile-table {\n        display: none;\n    }\n    .col-chart-6 {\n        width: 45vw;\n    }\n\n    .col-money-5 {\n        width: 18vw;\n    }\n\n    .person-info {\n        background-color: #FFFFFF;\n        margin-top: 3vh;\n        width: 75vw;\n    }\n\n    .person-info-item {\n        width: 45vw;\n    }\n\n    .btn-save {\n        cursor: pointer;\n        width: 10vw;\n        padding: 5px;\n        background: #2CA5EC;\n        box-shadow: 4px 5px 25px rgba(27, 27, 27, 0.08);\n        border-radius: 5px;\n    }\n}\n\n\n.person-body {\n    background-color: #FAFAFA;\n    padding: 5vmax;\n}\n\n.person-info {\n    background-color: #FFFFFF;\n    margin-top: 3vh;\n}\n\n.person-input {\n    background-color: #FAFAFA;\n}\n\n\n\n.btn-save:hover {\n    background: #0f95e3;\n}\n\n.text-btn-save {\n    color: #FFFFFF;\n}\n\n.text-main {\n    cursor: pointer;\n}\n\n.text-change-password {\n    font-family: 'Raleway';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 130%;\n    /* identical to box height, or 16px */\n\n    font-feature-settings: 'pnum' on, 'lnum' on;\n\n    /* Текст */\n\n    color: #3F3F3F;\n\n    cursor: pointer;\n}\n\n.chart-container {\n    height: 40vh;\n    /* width: 100vw; */\n}\n\n.bluemarker::marker {\n    color: #0088FE;\n    /* font-size: 1.5em; */\n}\n\n.greenmarker::marker {\n    color: #00C49F;\n}\n\n.orangemarker::marker {\n    color: #FFBB28;\n}\n\n.bg-w {\n    background-color: #FFFFFF;\n}\n\n.brd-r5 {\n    border-radius: 5px;\n}\n\n.fs-13 {\n    font-size: 13px;\n}\n\n.h-text {\n    height: 3vh;\n}\n\n.bl {\n    border-left: rgba(0, 0, 0, 0.08);\n    border-left-width: 2px;\n    border-left-style: solid;\n}\n\n.font-obj-text-sel {\n    font-family: 'Raleway';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 15px;\n    color: black;\n}\n\n.credit-info {\n    color: #0088FE;\n    cursor: pointer;\n}\n\n.credit-info:hover {\n    font-weight: bold;\n}\n\n.font-filter-credit {\n    font-family: 'Raleway';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 11px;\n    color: black;\n}\n\n.credit-hidden {\n    display: none;\n}\n\n.btn-add-test {\n    background-color: #e3dfdf;\n    display: flex;\n    justify-content: center;\n    border-radius: 10px;\n}\n\n.btn-add-test :hover {\n    background-color: #838181;\n}\n\n.p-7 {\n    padding: 7px;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
